import React, { useEffect } from "react";
import { useState } from "react";
import ConfirmBet from "../confirmBet";
import Selection from "../selection";
import { useLocation } from "react-router-dom";
import { TbPlayFootball } from "react-icons/tb"
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import bettingService from "../../../api/services/bettingService";
import { playSong } from "../../common/actions/common.actions";
import { useDispatch } from "react-redux";
import Modal from "../../common/components/modal";
import { useSelector } from 'react-redux';
import { selectLoginData } from "../login/login.actions";
import { setConfirmData } from '../../common/actions/common.actions';
import dashboardService from "../../../api/services/dashboardService";

const Footer = ({ selectedMatches, fromBody = false, showToastMessage, handleRemoveCard }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [showSelectedMatches, setShowSelectedMatches] = useState(false);
    const [showConfirmScreen, setShowConfirmScreen] = useState(false);
    const [betAmount, setBetAmount] = useState('');
    const [maxBetAmount, setMaxBetAmount] = useState(0);
    const [minBetAmount, setMinBetAmount] = useState(0);
    const [balance, setBalance] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState('');

    const handleSongClick = async () => {
        dispatch(playSong());
    };

    const handleConfirmData = (data) => {
        dispatch(setConfirmData(data));
    };
    const { userDetails } = useSelector(selectLoginData);
    const { confirmData } = useSelector((state) => state.common);

    useEffect(() => {
        if (userDetails) {
            const userDetail = userDetails;
            setBalance(userDetail.balance);
            if (fromBody) {
                setMaxBetAmount(userDetail.betLimitForSingle);
            } else {
                setMaxBetAmount(userDetail.betLimitForMix);
            }
            if (confirmData) {
                setBetAmount(confirmData.betAmount || 0);
            }
        }
    }, [fromBody, confirmData]);

    const openModal = (title, content) => {
        setModalTitle(title);
        setModalContent(content);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        // navigate(-1);
    };

    const validation = () => {
        if (!selectedMatches || (selectedMatches && selectedMatches.length < 1)) {
            return "Please choose at least 1 match!";
        } else if (betAmount && betAmount > balance) {
            return `Bet amount should be less than your balance: ${balance}!`;
        } else if (betAmount && betAmount > maxBetAmount) {
            return `Bet amount should be less than ${maxBetAmount}!`; // maxBetAmount is the maximum limit set by the user (BET LIMIT)
        } else if (location.pathname === '/maungg') {
            if (selectedMatches && selectedMatches.length < 2) {
                return "Please choose at least 2 matches!";
            }
        }
    };

    const fetchLock = async () => {
        try {
            const userId = Number(userDetails.userId);
            const response = await dashboardService.getBalanceForDashboard(userId).then((response) => response.json());
            if (response.userInfo) {
                const updatedUserDetails = response.userInfo[0];
                if (updatedUserDetails.lock) {
                    localStorage.removeItem('token');
                    localStorage.removeItem('userDetails');
                    localStorage.removeItem('confirmData');
                    navigate("/login");
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    useEffect(() => {
        fetchLock();
    }, []);


    const handleConfirm = async () => {
        try {
            fetchLock();
            //const response = await bettingService.getMinMax();
            const response = await bettingService.getMinMax2(); // (BET LIMIT)
            if (!response.ok) {
                throw new Error("Failed to fetch min/max bet amounts.");
            }
            const data = await response.json();
            // const gamblingTypeInfo = data.find(typeInfo => typeInfo.gamblingTypeId === (fromBody ? 1 : 2));
            // fetch both gambling Type Limit and Mix Count Limit (BET LIMIT)
            const gamblingTypeInfo = data.gamblingType.find(typeInfo => typeInfo.gamblingTypeId === (fromBody ? 1 : 2)); 
            if (gamblingTypeInfo) {
                setMinBetAmount(gamblingTypeInfo.minBetAmount);
            }
            const error = validation(gamblingTypeInfo);
            // get Mix Count Limit (BET LIMIT)
            const mixLimit = data.gamblingLimit[selectedMatches.length - 1]?.betLimit;
            if (error) {
                openModal('777 Soccer', error);
                return;
            }

            if (betAmount < gamblingTypeInfo.minBetAmount) {
                openModal('777 Soccer', `Bet amount should be greater than ${gamblingTypeInfo.minBetAmount}!`);
                return;
            }
            if (!fromBody && betAmount && betAmount > mixLimit) {
                openModal('777 Soccer', `Bet amount for ${selectedMatches.length} mix should be less than ${mixLimit}!`);
                return;
            }
            handleConfirmData({ betAmount, selectedMatches, isMix: location.pathname === '/maungg' ? true : false });
            handleSongClick();
            navigate("/confirm-bet");
        } catch (error) {
            console.error("Error fetching min/max bet amounts:", error);
        }
    };

    const handleClose = () => {
        console.log("closed!");
    };

    const handleBetAmountChange = (value, balance, setBetAmount) => {
        // Allow empty string (clear)
        if (value === '') {
            setBetAmount('');
            return;
        }

        const num = Math.floor(Number(value));

        // Invalid or zero and negative
        if (isNaN(num) || num <= 0) {
            return;
        }

        // Enforce limit: must be <= maxBetAmount and <= balance
        if (num <= maxBetAmount && num <= balance) {
            setBetAmount(num);
        }
    }

    return (
        <div className="px-4 bg-gradient-to-r from-[#228B22] via-emerald-600 to-[#1F5F1F] font-bold font-myanmarSansPro border-t border-white/20 shadow-lg">
            <div className="w-full flex items-center justify-between pt-2 pb-4 gap-2 ">
                {isModalOpen && (
                    <Modal title={modalTitle} content={modalContent} onClose={closeModal} />
                )}
                <div className="flex items-center">
                    <label className="ml-2 text-sm font-semibold text-white whitespace-nowrap">{t('betAmount')}</label>
                    {/* <div className="w-2 h-2 bg-[#FFD700] rounded-full animate-pulse"></div> */}
                </div>
                <input
                    type="number"
                    inputMode='numeric'
                    value={betAmount}
                    onChange={(e) => handleBetAmountChange(e.target.value, balance, setBetAmount)}
                    className="flex-1 w-full h-10 px-1 border-2 border-white/30 rounded-xl focus:outline-none focus:border-[#FFD700] focus:ring-2 focus:ring-[#FFD700]/50 text-gray-800 bg-white/90 backdrop-blur-sm text-right font-bold placeholder-gray-500"
                    placeholder="Amount"
                />
                <button className="z-10" onClick={handleConfirm}>
                    <div className="cursor-pointer bg-gradient-to-r from-[#FFD700] to-yellow-400 text-gray-900 border border-yellow-300 py-2 px-2 rounded-xl whitespace-nowrap font-bold hover:from-yellow-400 hover:to-[#FFD700] transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-105">
                        {t('bet')}
                    </div>
                </button>
                {location.pathname === '/maungg' && (
                    <div className="flex text-white bg-white/20 backdrop-blur-sm border border-white/30 py-2 px-1 ml-1 rounded-xl justify-center items-center min-w-[45px] hover:bg-white/30 transition-all duration-200">
                        <span className="text-sm font-bold">{selectedMatches.length}</span>
                        {/* <TbPlayFootball className="ml-1" color="#FFD700" size={18} /> */}
                    </div>
                )}
                {/* <div
                        className={`fixed top-0 left-0 w-full h-screen bg-white z-50 transform transition-transform ${showSelectedMatches ? 'translate-x-0' : '-translate-x-full'
                          }`}
                      >
                        <Selection
                          onClose={() => {
                setShowSelectedMatches(false);
                handleSongClick();
                          }}
                          selectedMatches={selectedMatches}
                          betAmount={betAmount}
                          handleRemoveCard={handleRemoveCard}
                          handleConfirm={handleConfirm}
                        />
                      </div> */}
                <div
                    className={`fixed top-0 left-0 w-full h-[100dvh] bg-white z-50 transform transition-transform ${showConfirmScreen ? 'translate-x-0' : '-translate-x-full'
                        }`}
                >
                    {/* <ConfirmBet onClose={handleClose} handleRemoveCard={handleRemoveCard} /> */}
                </div>
            </div>
        </div>
    );
};

export default Footer;
